import styled from "styled-components";
import { TableCell, TableRow } from "@mui/material";

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DesignationsReadOnly = ({
  k, row, onClickEdit, handleDeleteClick,
  page, rowsPerPage, tableFontSize,
  SubmitButton
}) => {
  return (
    <TableRow key={k} name={row.categ}>
      <TableCell
        style={{ width: 60 }}
        component="th"
        scope="row"
        sx={{ fontSize: tableFontSize }}
      >
        {page * rowsPerPage + k + 1}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: tableFontSize }}>
        {row?.name}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: tableFontSize }}>
        {row?.level}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: tableFontSize }}>
        <ButtonWrapper>
          <SubmitButton
            type="button"
            sx={{
              backgroundColor: "#ed6c02",
              color: "lightgreen",
              height: "35px",
              margin: 0,
            }}
            onClick={() => onClickEdit(k, row)}
          >
            Edit
          </SubmitButton>

          <SubmitButton
            type="button"
            sx={{
              backgroundColor: "#D32F2F",
              color: "lightgreen",
              height: "35px",
            }}
            onClick={(e) => handleDeleteClick(e, k, row)}
          >
            Delete
          </SubmitButton>
        </ButtonWrapper>
      </TableCell>
    </TableRow>
  );
};

export default DesignationsReadOnly;
